<template>
  <div class="relative w-full" v-click-outside="closeDropdown">
    <div
      class="w-full px-3 py-2 border rounded-md cursor-pointer bg-white min-h-[42px] flex items-center justify-between focus-within:outline-none focus-within:ring-2 focus-within:ring-indigo-500"
      @click="toggleDropdown"
      tabindex="0"
      @keydown.enter.prevent="toggleDropdown"
      @keydown.space.prevent="toggleDropdown"
    >
      <div class="flex flex-wrap gap-1 flex-1 min-w-0">
        <span v-if="selectedOptions.length === 0" class="text-gray-400 text-sm">
          {{ placeholder }}
        </span>
        <span
          v-for="option in selectedOptions"
          :key="option.value"
          class="inline-flex items-center gap-1 px-2 py-0.5 bg-indigo-100 text-indigo-700 rounded text-sm whitespace-nowrap"
        >
          <span class="truncate max-w-[120px]">{{ option.label }}</span>
          <button
            type="button"
            @click.stop="removeOption(option.value)"
            class="hover:text-indigo-900 flex-shrink-0"
          >
            <svg class="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
            </svg>
          </button>
        </span>
      </div>
      <svg class="w-5 h-5 text-gray-400 flex-shrink-0 ml-2" :class="{ 'transform rotate-180': isOpen }" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
      </svg>
    </div>

    <div
      v-if="isOpen"
      class="absolute z-10 w-full mt-1 bg-white border rounded-md shadow-lg max-h-60 overflow-auto"
    >
      <div
        v-for="option in options"
        :key="option.value"
        class="px-3 py-2 hover:bg-indigo-50 cursor-pointer flex items-center gap-2"
        @click="toggleOption(option.value)"
      >
        <input
          type="checkbox"
          :checked="isSelected(option.value)"
          class="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
          @click.stop
        />
        <span class="text-sm text-gray-700">{{ option.label }}</span>
      </div>
      <div v-if="options.length === 0" class="px-3 py-2 text-sm text-gray-500">
        No options available
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseMultiSelect',
  props: {
    modelValue: {
      type: Array,
      default: () => [],
    },
    options: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: 'Select options',
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    selectedOptions() {
      return this.options.filter(opt => this.modelValue.includes(opt.value));
    },
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    closeDropdown() {
      this.isOpen = false;
    },
    toggleOption(value) {
      const newValue = [...this.modelValue];
      const index = newValue.indexOf(value);
      
      if (index > -1) {
        newValue.splice(index, 1);
      } else {
        newValue.push(value);
      }
      
      this.$emit('update:modelValue', newValue);
    },
    removeOption(value) {
      const newValue = this.modelValue.filter(v => v !== value);
      this.$emit('update:modelValue', newValue);
    },
    isSelected(value) {
      return this.modelValue.includes(value);
    },
  },
  directives: {
    'click-outside': {
      mounted(el, binding) {
        el.clickOutsideEvent = function(event) {
          if (!(el === event.target || el.contains(event.target))) {
            binding.value();
          }
        };
        document.addEventListener('click', el.clickOutsideEvent);
      },
      unmounted(el) {
        document.removeEventListener('click', el.clickOutsideEvent);
      },
    },
  },
};
</script>
